/* eslint-disable @typescript-eslint/no-explicit-any */
import { token } from '@bynder/design-system';
import { useCardWidgetMutations } from '../../mutations/widgets/card';
import type { WidgetAlignment, CardWidget } from '../../types';
import { useInspectorStore } from '../../stores/inspectorStore';
import styled from 'styled-components';
import { Sortable } from './Card/SortableGrid';
import { CSS_CLASSES, CSS_PROPERTIES } from '../guides/Inspector/constants';
import { useCustomCSSEditor } from '../../hooks/useCustomCSSEditor';

const CardWidget = ({ cardWidget }: { cardWidget: CardWidget }) => {
  const { widgetSettings } = useInspectorStore();
  const { rearrange } = useCardWidgetMutations();
  const isActiveWidget = widgetSettings?.widgetId === cardWidget?.id;
  const handleDragEnd = (from: number, to: number) => {
    const cardId = cardWidget.cards[from].id;
    rearrange.mutate({ from, to, cardId });
  };
  const { getValueFromStyle } = useCustomCSSEditor(cardWidget.style.stylesheet);

  return (
    <Sortable
      widgetStyle={cardWidget.style.stylesheet}
      handleDragEnd={handleDragEnd}
      Container={(props: any) => (
        <StyledCardContainer
          {...props}
          $width={
            getValueFromStyle(CSS_PROPERTIES.WIDTH, CSS_CLASSES.CARD) ||
            cardWidget.style.size
          }
          $alignment={
            getValueFromStyle(CSS_PROPERTIES.JUSTIFY_CONTENT) ||
            cardWidget.style.alignment
          }
        />
      )}
      items={cardWidget.cards}
      isActiveWidget={isActiveWidget}
    />
  );
};

const StyledCardContainer = styled.ul<{
  $width: number;
  $alignment: WidgetAlignment;
}>`
  display: flex;
  gap: ${token.spacing6};
  justify-content: ${({ $alignment }) => $alignment};
  flex-wrap: wrap;

  > li {
    width: ${props => props.$width}px;
  }
  li div {
    flex-grow: 1;
  }
`;

export default CardWidget;
